import { useCouriersList } from '../hooks/use-couriers-list.hook';
import { CreateCourierModal } from '../actions/add-courier/add-courier-action.component';
import { CourierListActions } from '../actions/courier-list.actions';
import { Snackbar } from '../../../../ui/components/pure/snackbar/snackbar.component';
import { BatchImportCouriersAction } from '../actions/batch-import/batch-import-couriers-action.component';
import { BatchExportCouriersAction } from '../actions/batch-export/batch-export-couriers-action.component';

type UseCouriersListResult = ReturnType<typeof useCouriersList>;
type Actions = UseCouriersListResult['actions'];

export function CouriersListActionsObserver({ actions, projectID }: { actions: Actions; projectID: string }) {
  switch (actions.currentAction) {
    case CourierListActions.ADD_COURIER:
      return (
        <CreateCourierModal
          projectID={projectID}
          onSuccess={() => actions.setAction(CourierListActions.ADD_COURIER_SUCCESS)}
          onAbort={() => actions.setAction(null)}
        />
      );
    case CourierListActions.ADD_COURIER_SUCCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          The courier has been created
        </Snackbar>
      );
    case CourierListActions.BATCH_IMPORT:
      return (
        <BatchImportCouriersAction
          projectID={projectID}
          onSuccess={() => actions.setAction(CourierListActions.BATCH_IMPORT_SUCCESS)}
          onAbort={() => actions.setAction(null)}
        />
      );
    case CourierListActions.BATCH_IMPORT_SUCCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          Couriers imported
        </Snackbar>
      );
    case CourierListActions.BATCH_EXPORT:
      return (
        <BatchExportCouriersAction
          projectID={projectID}
          onSuccess={() => actions.setAction(CourierListActions.BATCH_EXPORT_SUCCESS)}
          onAbort={() => actions.setAction(null)}
        />
      );
    case CourierListActions.BATCH_EXPORT_SUCCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          Couriers exported
        </Snackbar>
      );
    default:
      return null;
  }
}
